import MobileDetect from "mobile-detect"

const isMobileDevice = () => {
  const detect = new MobileDetect(window.navigator.userAgent)
  return detect.mobile()
}

export default isMobileDevice
